import type { HubServiceApiEndpoint } from '@robovision/hub'
import { InferenceServiceId } from './InferenceServiceId'


function prefixUrl (url: string | undefined): string | undefined {
  if (!url) return url
  return `${document.location.origin}${url}`
}

export class InferenceApiEndpoint {
  private readonly endpoint: HubServiceApiEndpoint

  constructor (endpoint: HubServiceApiEndpoint) {
    this.endpoint = endpoint
  }

  public static fromResponse (endpoint: HubServiceApiEndpoint): InferenceApiEndpoint {
    return new InferenceApiEndpoint(endpoint)
  }

  public static fromEmpty (): InferenceApiEndpoint {
    return new InferenceApiEndpoint({
      apiUrl: undefined,
      description: undefined,
      docsUrl: undefined,
      healthUrl: undefined,
      name: undefined,
      serviceId: InferenceServiceId.EMPTY,
    })
  }

  public get serviceId (): string {
    return this.endpoint.serviceId
  }

  public get name (): string | undefined {
    return this.endpoint.name
  }

  public get description (): string | undefined {
    return this.endpoint.description
  }

  public get apiUrl (): string | undefined {
    return prefixUrl(this.endpoint.apiUrl)
  }

  public get docsUrl (): string | undefined {
    return prefixUrl(this.endpoint.docsUrl)
  }

  public get healthUrl (): string | undefined {
    return prefixUrl(this.endpoint.healthUrl)
  }
}
